/**
 * Hook for checking service permissions in MallManagement pages
 * Usage: const userHasPermission = useServicePermission('Cargo');
 */

import { useState, useEffect } from 'react';
import Services from 'src/services/Services';
import { checkServicePermission } from 'src/utils/servicePermissions';
import { toast } from 'react-toastify';

export const useServicePermission = (serviceName) => {
  const [hasPermission, setHasPermission] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const checkPermission = async () => {
      try {
        setLoading(true);
        
        // Get token and mallID from localStorage
        const token = localStorage.getItem('tokenForService');
        const mallID = localStorage.getItem('mallID');

        if (!token || !mallID) {
          setError('Yetkilendirme anahtarı veya AVM ID bulunamadı.');
          setHasPermission(false);
          setLoading(false);
          return;
        }

        // Get mall information
        const response = await Services.GetMallInformation(token, mallID);

        if (response.data && response.data.result) {
          const mallData = response.data.result;
          const permission = checkServicePermission(mallID, serviceName, mallData);
          setHasPermission(permission);
          setError(null);
        } else {
          setError('AVM bilgileri alınamadı.');
          setHasPermission(false);
        }
      } catch (err) {
        console.error('Hizmet izni kontrol edilirken hata:', err);
        setError(err.message || 'Bir hata oluştu.');
        setHasPermission(false);
      } finally {
        setLoading(false);
      }
    };

    checkPermission();
  }, [serviceName]);

  return { hasPermission, loading, error };
};

export default useServicePermission;

